import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import React from "react";
import { Link } from "react-router-dom";
import UserAccessPermission from "../../dashboard/user-access-permission";
// import "./style.css";
export default function Landing() {
	const [visible, setVisible] = React.useState(false);
	return (
		<div>
			{/* <Sidebar
				visible={visible}
				onHide={() => setVisible(false)}
				style={{ backgroundColor: "#FECD08" }}
			></Sidebar> */}
			<div className="flex gap-1 p-4 bg-secondary-darkGray">
				{/* <Button icon="pi pi-list" onClick={() => setVisible(true)} /> */}
				<span className="fas fa-arrow-left text-white my-auto"></span>
				<Link to="/" className="justify-end underline text-white">
					Back to Dashboard
				</Link>
			</div>
			<div className="p-4">
				<UserAccessPermission />
			</div>
		</div>
	);
}
